const owners = new Set<symbol>()
let originalOverflow: string | undefined

export function lockBodyScroll(owner: symbol) {
    if (typeof document === 'undefined' || owners.has(owner)) { return }
    if (!owners.size) { originalOverflow = document.body.style.overflow }
    owners.add(owner)
    document.body.style.overflow = 'hidden'
}

export function unlockBodyScroll(owner: symbol) {
    if (typeof document === 'undefined' || !owners.delete(owner) || owners.size) { return }
    document.body.style.overflow = originalOverflow || ''
    originalOverflow = undefined
}
